import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ea394a0")

_pushScopeId("data-v-0ea394a0")
const _hoisted_1 = { class: "appointment-contact" }
const _hoisted_2 = { class: "heading-title" }
const _hoisted_3 = { class: "auto-complete" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProgressIndicator = _resolveComponent("ProgressIndicator")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PoweredBy = _resolveComponent("PoweredBy")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_ProgressIndicator, {
          currentStep: 3,
          steps: 4
        })
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, _toDisplayString(_ctx.$t('appointmentContact.heading')), 1)
    ]),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_AutoComplete, {
            control: _ctx.jobManager,
            "item-text": _ctx.autoCompleteData.itemText,
            items: _ctx.autoCompleteData.managers,
            placeholder: _ctx.$t('appointmentContact.selectJobManager'),
            class: "full-width",
            onItemSelect: _ctx.onJobManagerSelect
          }, null, 8, ["control", "item-text", "items", "placeholder", "onItemSelect"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          disabled: !_ctx.enableNextStepButton,
          showLoading: _ctx.showLoading,
          size: "large",
          class: "full-width",
          onClick: _ctx.markAsAlreadyHadAppointment
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('appointmentContact.nextStep')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "showLoading", "onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          size: "large",
          disabled: _ctx.disablePreviousButton,
          class: "full-width outlined",
          onClick: _ctx.goToBackPage
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('appointmentContact.previousStep')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withId(() => [
        _createVNode(_component_PoweredBy)
      ]),
      _: 1
    })
  ]))
})